import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { ClipboardModule } from "ngx-clipboard";
import { TranslateModule } from "@ngx-translate/core";
import { InlineSVGModule } from "ng-inline-svg";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// Highlight JS
import {HighlightModule,  HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { SplashScreenModule } from "./_metronic/partials/layout/splash-screen/splash-screen.module";
import { NotFoundComponent } from "./not-found/not-found.component";
import { AppHttpInterceptor } from "./interceptors/http.interceptor";
import { UnsubscribeComponent } from "./unsubscribe/unsubscribe.component";
import { SharedModule } from "./modules/shared/shared.module";

@NgModule({ declarations: [AppComponent, NotFoundComponent, UnsubscribeComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 4000,
        }),
        SplashScreenModule,
        TranslateModule.forRoot(),
        HighlightModule,
        ClipboardModule,
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        SharedModule], providers: [
        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    typescript: () => import('highlight.js/lib/languages/typescript'),
                    css: () => import('highlight.js/lib/languages/css'),
                    xml: () => import('highlight.js/lib/languages/xml')
                },
            },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppHttpInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
